



























import { Vue, Component, Emit } from 'vue-property-decorator';

@Component({})
export default class DiscardOrganisationCreationModal extends Vue {
  @Emit('exit')
  triggerExit() {
    this.triggerClose();
  }

  @Emit('close')
  triggerClose() {
    return;
  }
}
